import React, { useState } from "react";
import { routes } from "../routes";
import { Link } from "react-router-dom";
import { formatCategoryString, normalizeString } from "../utils";

export default function Home() {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredRoutes = routes.filter((r) => {
    const normalizedPath = normalizeString(r.path);
    const normalizedSearchTerm = normalizeString(searchTerm);

    const searchTerms = normalizedSearchTerm.split(" ");

    return searchTerms.every((term) => normalizedPath.includes(term));
  });

  return (
    <div
      style={{
        position: "relative",
        background: `url('/bg.png')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        overflow: "scroll",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px",
        }}
      >
        <input
          style={{
            position: "sticky",
            top: "0px",
            marginBottom: "20px",
          }}
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by path"
        />
        {routes.length && !filteredRoutes.length && <p>No Results!</p>}
        {filteredRoutes.map((r) => {
          return (
            <Link
              target="_blank"
              style={{ color: "white", width: "max-content" }}
              to={r.path}
            >
              {formatCategoryString(r.path)}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
